import Api from "~/service/Api";

class ProviderStatisticRepository {
  fetchOne(providerId, query) {
    return Api.get(`/provider/statistics/${providerId}`, query);
  }
}

export default ProviderStatisticRepository;
